module.exports = {"error":{"invalidLogin":"Acesso não autorizado. Se o exame for recente, tente novamente mais tarde.","authorizeFailed":"Houve um erro ao verificar suas credenciais, tente novamente","popupBlocked":"É necessário permitir popup para acessar"}}


//////////////////
// WEBPACK FOOTER
// ./src/messages.json
// module id = 346
// module chunks = 0